import React, { useEffect, useState, useCallback } from 'react'
import { object, string, array } from 'prop-types'
import { useMedia } from 'use-media'

import mediaQueries from '@/layout/media-queries'
import Tabs from '@/components/Product/Tabs'
import {
  wrapperCss,
  headerCss,
  nameCss,
  descriptionWrapperCss,
  descriptionCss,
} from './Header.style'

const Header = ({
  description,
  name,
  activeTab,
  tabs,
  innerRef,
  className,
  dataTest,
}) => {
  const isMobile = useMedia({ maxWidth: mediaQueries.BASE_SMALL_SIZE - 1 })

  const [isCompact, setIsCompact] = useState(false)

  const handleScroll = useCallback(
    () => {
      const position = window.pageYOffset
      const localIsCompact = position > 0
      if (isCompact !== localIsCompact) {
        setIsCompact(localIsCompact)
      }
    },
    [isCompact]
  )

  useEffect(
    () => {
      window.addEventListener('scroll', handleScroll)

      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    },
    [handleScroll]
  )

  const dataTests = {
    header: dataTest ? `${dataTest}-header` : null,
    name: dataTest ? `${dataTest}-name` : null,
    icon: dataTest ? `${dataTest}-icon` : null,
    description: dataTest ? `${dataTest}-description` : null,
    actionBtn: dataTest ? `${dataTest}-action-btn` : null,
  }

  return (
    <>
      <div
        css={wrapperCss}
        ref={innerRef}
        className={className}
        data-test={dataTests.header}
      >
        <div css={headerCss(isCompact)}>
          <div data-test={dataTests.name} css={nameCss}>
            {name}
          </div>

          <div data-test={dataTests.description} css={descriptionWrapperCss}>
            <div css={descriptionCss(isCompact)}>{description}</div>
          </div>
        </div>

        {!isMobile && <Tabs activeTab={activeTab} tabs={tabs} />}
      </div>

      {isMobile && <Tabs activeTab={activeTab} tabs={tabs} />}
    </>
  )
}

Header.propTypes = {
  description: string,
  name: string,
  activeTab: string,
  innerRef: object,
  className: string,
  dataTest: string,
  tabs: array,
}

export default React.forwardRef((props, ref) => (
  <Header innerRef={ref} {...props} />
))
